// WP-0.7 (§18.1 mobile <640px): bottom nav 5 — Home · Inbox · big center ＋ · Money · Menu.
import { Menu, Plus } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useInboxBadgeCount } from '../lib/inbox';
import { Icon } from './Icon';

const tabClass = ({ isActive }: { isActive: boolean }): string =>
  `flex flex-1 flex-col items-center gap-0.5 py-2 text-xs ${isActive ? 'text-primary' : 'text-muted'}`;

export function BottomNav({ onOpenMenu }: { onOpenMenu: () => void }): React.JSX.Element {
  // IN-5: same badge count as the sidebar.
  const inboxBadge = useInboxBadgeCount();
  return (
    <nav
      aria-label="Mobile"
      className="flex items-stretch border-t border-border bg-surface sm:hidden"
    >
      <NavLink to="/" end className={tabClass}>
        <Icon name="LayoutDashboard" />
        Home
      </NavLink>
      <NavLink to="/inbox" className={({ isActive }) => `relative ${tabClass({ isActive })}`}>
        <Icon name="Inbox" />
        Inbox
        {inboxBadge > 0 && (
          <span className="absolute right-3 top-1 rounded-full bg-danger px-1 text-[9px] font-medium text-white">
            {inboxBadge}
          </span>
        )}
      </NavLink>
      <button className="flex flex-1 flex-col items-center justify-center" aria-label="Quick add">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-primary-ink hover:opacity-90 active:opacity-80">
          <Plus size={22} />
        </span>
      </button>
      <NavLink to="/tx" className={tabClass}>
        <Icon name="ArrowLeftRight" />
        Money
      </NavLink>
      <button
        className="flex flex-1 flex-col items-center gap-0.5 py-2 text-xs text-muted hover:text-ink"
        onClick={onOpenMenu}
      >
        <Menu size={20} />
        Menu
      </button>
    </nav>
  );
}
